import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "row g-3 align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "col-12 col-lg d-flex flex-wrap gap-3 align-items-center justify-content-center justify-content-lg-end"
}
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = {
  class: "btn-group btn-group-sm",
  role: "group",
  "aria-label": "Filtro de Activos"
}
const _hoisted_7 = { class: "d-flex align-items-center gap-2" }
const _hoisted_8 = {
  class: "btn-group btn-group-sm",
  role: "group",
  "aria-label": "Filtro de Licencia de Distribuidor"
}
const _hoisted_9 = {
  key: 0,
  class: "row g-3 align-items-center justify-content-center justify-content-lg-end mt-2"
}
const _hoisted_10 = { class: "col-12 col-md-auto d-flex flex-wrap align-items-center gap-2 justify-content-center justify-content-md-start" }
const _hoisted_11 = {
  class: "btn-group btn-group-sm",
  role: "group",
  "aria-label": "Filtro de Paquete"
}
const _hoisted_12 = { class: "col-12 col-md-auto" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = {
  key: 1,
  class: "row"
}
const _hoisted_16 = {
  class: "col-12 col-lg-6 left-team border-end team collapse collapse-horizontal show d-lg-block",
  id: "teamLeft"
}
const _hoisted_17 = { class: "left-team-header mb-2 pe-2 d-flex flex-row align-items-center" }
const _hoisted_18 = { class: "flex-grow-1" }
const _hoisted_19 = { class: "mb-0 text-center" }
const _hoisted_20 = { class: "fw-bold h5 mb-0" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "small text-center" }
const _hoisted_23 = {
  class: "col-12 col-lg-6 right-team d-lg-block team collapse collapse-horizontal",
  id: "teamRight"
}
const _hoisted_24 = { class: "right-team-header mb-2 ps-2 d-flex flex-row align-items-center" }
const _hoisted_25 = { class: "flex-grow-1" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "fw-bold h5 mb-0" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "small text-center" }
const _hoisted_30 = {
  key: 2,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!
  const _component_team_member = _resolveComponent("team-member")!

  return (_ctx.loading || _ctx.team != undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-12 col-lg-auto text-center text-lg-start" }, [
              _createElementVNode("h4", { class: "mb-0" }, "Afiliados directos")
            ], -1)),
            (_ctx.hasTeamMembers && !_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "filter-label" }, "Activos:", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "active",
                        id: "activeOn",
                        autocomplete: "off",
                        value: "activeOn",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showActive) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.showActive]
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("label", {
                        class: "btn btn-outline-secondary",
                        for: "activeOn",
                        title: "Activa"
                      }, [
                        _createElementVNode("i", { class: "fas fa-check-circle text-success" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "active",
                        id: "activeOff",
                        autocomplete: "off",
                        value: "activeOff",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showActive) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.showActive]
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("label", {
                        class: "btn btn-outline-secondary",
                        for: "activeOff",
                        title: "Inactiva"
                      }, [
                        _createElementVNode("i", { class: "fas fa-times-circle text-danger" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "active",
                        id: "activeAll",
                        autocomplete: "off",
                        value: "activeAll",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showActive) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.showActive]
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("label", {
                        class: "btn btn-outline-secondary",
                        for: "activeAll",
                        title: "Todos"
                      }, [
                        _createElementVNode("i", { class: "fas fa-plus-circle text-dark" })
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "filter-label text-nowrap" }, "Licencia:", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "distributor",
                        id: "distributorOn",
                        autocomplete: "off",
                        value: "distributorOn",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDistributor) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.showDistributor]
                      ]),
                      _cache[17] || (_cache[17] = _createElementVNode("label", {
                        class: "btn btn-outline-secondary",
                        for: "distributorOn",
                        title: "Activa"
                      }, [
                        _createElementVNode("i", { class: "fas fa-check-circle text-success" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "distributor",
                        id: "distributorOff",
                        autocomplete: "off",
                        value: "distributorOff",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDistributor) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.showDistributor]
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("label", {
                        class: "btn btn-outline-secondary",
                        for: "distributorOff",
                        title: "Inactiva"
                      }, [
                        _createElementVNode("i", { class: "fas fa-times-circle text-danger" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "distributor",
                        id: "distributorAll",
                        autocomplete: "off",
                        value: "distributorAll",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDistributor) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.showDistributor]
                      ]),
                      _cache[19] || (_cache[19] = _createElementVNode("label", {
                        class: "btn btn-outline-secondary",
                        for: "distributorAll",
                        title: "Todos"
                      }, [
                        _createElementVNode("i", { class: "fas fa-plus-circle text-dark" })
                      ], -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.hasTeamMembers && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "filter-label" }, "Paquete:", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "btn-check",
                      id: "pkgLite",
                      autocomplete: "off",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.packageFilter.lite) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.packageFilter.lite]
                    ]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline-secondary d-inline-flex align-items-center gap-1", { 'pkg-bg-gtr-go': _ctx.packageFilter.lite }]),
                      for: "pkgLite",
                      title: "Go"
                    }, [
                      _createVNode(_component_package_icon, { product: "gtr-go" }),
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, "Go", -1))
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "btn-check",
                      id: "pkgBasic",
                      autocomplete: "off",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.packageFilter.basic) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.packageFilter.basic]
                    ]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline-secondary d-inline-flex align-items-center gap-1", { 'pkg-bg-gtr-fly': _ctx.packageFilter.basic }]),
                      for: "pkgBasic",
                      title: "Fly"
                    }, [
                      _createVNode(_component_package_icon, { product: "gtr-fly" }),
                      _cache[23] || (_cache[23] = _createElementVNode("span", null, "Fly", -1))
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "btn-check",
                      id: "pkgVip",
                      autocomplete: "off",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.packageFilter.vip) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.packageFilter.vip]
                    ]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline-secondary d-inline-flex align-items-center gap-1", { 'pkg-bg-gtr-win': _ctx.packageFilter.vip }]),
                      for: "pkgVip",
                      title: "Win"
                    }, [
                      _createVNode(_component_package_icon, { product: "gtr-win" }),
                      _cache[24] || (_cache[24] = _createElementVNode("span", null, "Win", -1))
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "btn-check",
                      id: "pkgNone",
                      autocomplete: "off",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.packageFilter.none) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.packageFilter.none]
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("label", {
                      class: "btn btn-outline-secondary d-inline-flex align-items-center",
                      for: "pkgNone",
                      title: "Sin paquete"
                    }, [
                      _createElementVNode("span", null, "Sin paquete")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "aria-label": "Ordenar por",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sortOrder) = $event))
                  }, [...(_cache[27] || (_cache[27] = [
                    _createStaticVNode("<option value=\"ALF\" data-v-0b168e5a>Alfabético</option><option value=\"RANK_TOP\" data-v-0b168e5a>Rango: Mayor a menor</option><option value=\"RANK_LOW\" data-v-0b168e5a>Rango: Menor a mayor</option><option value=\"POINTS_TOP\" data-v-0b168e5a>Puntos: Más a menos</option><option value=\"POINTS_LOW\" data-v-0b168e5a>Puntos: Menos a más</option><option value=\"ACADEMY_CLOSE\" data-v-0b168e5a>Vencimiento de Academia: Más próximo</option><option value=\"ACADEMY_DISTANT\" data-v-0b168e5a>Vencimiento de Academia: Más Lejano</option>", 7)
                  ]))], 512), [
                    [_vModelSelect, _ctx.sortOrder]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[28] || (_cache[28] = [
                _createElementVNode("div", { class: "col-12 text-center" }, [
                  _createElementVNode("h3", null, [
                    _createElementVNode("i", { class: "fas fa-cog me-1 fa-spin" }),
                    _createTextVNode("Cargando...")
                  ])
                ], -1)
              ]))]))
            : (_ctx.hasTeamMembers && !_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "d-lg-none text-center text-secondary" }, [
                          _createElementVNode("h4", null, "Equipo Izquierdo")
                        ], -1)),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("i", {
                            class: _normalizeClass([
                    'fas me-2',
                    {
                      'fa-exclamation-triangle text-warning':
                        Number.parseFloat(_ctx.leftPercentage) > 100,
                    },
                  ])
                          }, null, 2),
                          _createElementVNode("i", {
                            class: _normalizeClass([
                    'fas me-2',
                    {
                      'fa-exclamation text-danger':
                        Number.parseFloat(_ctx.leftPercentage) < 20,
                    },
                  ])
                          }, null, 2),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.leftPercentage) + "%", 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, " Volumen Calificado: " + _toDisplayString(Number(_ctx.leftValidPoints).toLocaleString()), 1),
                        _createElementVNode("div", _hoisted_22, " Volumen Total: " + _toDisplayString(Number(_ctx.team?.leader.points.left).toLocaleString()), 1)
                      ]),
                      _cache[30] || (_cache[30] = _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary d-lg-none",
                          "data-bs-target": ".team",
                          "data-bs-toggle": "collapse"
                        }, [
                          _createElementVNode("i", { class: "fas fa-angle-double-right" })
                        ])
                      ], -1))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedTeam.leftTeam, (m) => {
                      return (_openBlock(), _createBlock(_component_team_member, {
                        key: m.leader.username,
                        "member-data": m.leader,
                        maxPointsPerUser: _ctx.team?.leader.nextRankMaxPoints,
                        "team-side": "left",
                        onRefresh: _cache[11] || (_cache[11] = (member, done) => _ctx.onMemberRefresh(member, 'left', done))
                      }, null, 8, ["member-data", "maxPointsPerUser"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[32] || (_cache[32] = _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary d-lg-none",
                          "data-bs-target": ".team",
                          "data-bs-toggle": "collapse"
                        }, [
                          _createElementVNode("i", { class: "fas fa-angle-double-left" })
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "d-lg-none text-center text-secondary" }, [
                          _createElementVNode("h4", null, "Equipo Derecho")
                        ], -1)),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.rightPercentage) + "%", 1),
                          _createElementVNode("i", {
                            class: _normalizeClass([
                    'fas ms-2',
                    {
                      'fa-exclamation-triangle text-warning':
                        Number.parseFloat(_ctx.rightPercentage) > 100,
                    },
                  ])
                          }, null, 2),
                          _createElementVNode("i", {
                            class: _normalizeClass([
                    'fas ms-2',
                    {
                      'fa-exclamation text-danger':
                        Number.parseFloat(_ctx.rightPercentage) < 20,
                    },
                  ])
                          }, null, 2)
                        ]),
                        _createElementVNode("div", _hoisted_28, " Volumen Calificado: " + _toDisplayString(Number(_ctx.rightValidPoints).toLocaleString()), 1),
                        _createElementVNode("div", _hoisted_29, " Volumen Total: " + _toDisplayString(Number(_ctx.team?.leader.points.right).toLocaleString()), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedTeam.rightTeam, (m) => {
                      return (_openBlock(), _createBlock(_component_team_member, {
                        key: m.leader.username,
                        "member-data": m.leader,
                        maxPointsPerUser: _ctx.team?.leader.nextRankMaxPoints,
                        "team-side": "right",
                        onRefresh: _cache[12] || (_cache[12] = (member, done) => _ctx.onMemberRefresh(member, 'right', done))
                      }, null, 8, ["member-data", "maxPointsPerUser"]))
                    }), 128))
                  ])
                ]))
              : (
          !_ctx.loading && _ctx.team?.rightTeam && _ctx.team?.leftTeam && _ctx.totalTeamMembers == 0
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("div", { class: "col-12" }, [
                      _createElementVNode("h3", { class: "text-center" }, "No hay miembros en este equipo")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}